/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class DependencyTrackControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createTeamAndSetupUser
   */
  static readonly CreateTeamAndSetupUserPath = '/api/v1/dtrack/createTeamAndSetupUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTeamAndSetupUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTeamAndSetupUser$Response(params: {
    body: {
[key: string]: string;
}
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DependencyTrackControllerService.CreateTeamAndSetupUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTeamAndSetupUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTeamAndSetupUser(params: {
    body: {
[key: string]: string;
}
  }): Observable<string> {

    return this.createTeamAndSetupUser$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
